<template>
  <div>
    <v-container fluid v-if="!authorizationInProgress">
      <v-form v-model="valid" ref="form">
        <v-card id="signin-form">
          <v-card-title>
            <span class="display-1">{{ t('Authentication') }}</span>
          </v-card-title>

          <v-card-text>
            <v-text-field
              :label="t('Email')"
              v-model="email"
              required
              :rules="emailRules"
              :error-messages="emailError"
              @keyup.enter="signIn"
            ></v-text-field>

            <v-text-field
              :label="t('Password')"
              v-model="password"
              :hint="t('At least 8 characters')"
              min="8"
              :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
              @click:append="() => (passwordVisible = !passwordVisible)"
              :type="passwordVisible ? 'text' : 'password'"
              :error-messagaes="t(passwordError)"
              required
              @keyup.enter="signIn"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <btn_ :action="signin" color="primary"></btn_>
            <!-- <v-btn @click="signIn" :disabled="loading" :loading="loading" light class="secondary">
        Sign in
        <span slot="loader" class="custom-loader">
          <v-icon light>cached</v-icon>
        </span>
      </v-btn> -->
          </v-card-actions>

          <v-divider></v-divider>
          <v-card-text> {{ t('Or sign in with') }}: </v-card-text>

          <v-card-actions>
            <btn_ :action="google" dark></btn_>
            <!-- <btn_ :action="facebook" dark></btn_> -->
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>

    <div class="d-flex align-center" v-if="authorizationInProgress" style="margin-top: 40px">
      <v-progress-circular indeterminate color="accent"></v-progress-circular>
      <div>{{ t('Authentication in progress...') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      first: '',
      email: '',
      password: '',
      emailRules: [v => !!v || this.t('Required')],
      passwordVisible: false,
      emailError: undefined,
      passwordError: undefined,
      signin: {
        caption: this.t('Sign in'),
        class: 'primary',
        promise: () => this.$store.dispatch('signInWithPassword', this),
      },
      google: {
        caption: 'Google',
        class: 'google',
        promise: () => this.$store.dispatch('signInWithProvider', 'google'),
      },
      facebook: {
        caption: 'Facebook',
        class: 'facebook',
        promise: () => this.$store.dispatch('signInWithProvider', 'facebook'),
      },
    }
  },
  computed: {
    error() {
      return this.$store.state.error
    },
    loading() {
      // console.log('compute loading ', this.$store.state.loading)
      return this.$store.state.loading
    },
    authorizationInProgress() {
      return this.$store.state.auth.authorizationInProgress
    },
  },
  watch: {
    error(v) {
      this.emailError = this.passwordError = undefined
      switch (v.code) {
        case 'auth/invalid-email':
          this.emailError = 'BadlyFormattedEmail'
          break
        case 'auth/user-not-found':
          this.emailError = 'UserNotFound'
          break
        case 'auth/wrong-password':
          this.passwordError = 'WrongPassword'
          break
        case 'auth/network-request-failed':
          this.passwordError = 'NetworkFailed'
          break
        default:
          this.emailError = v.code + ': ' + v.message
      }
    },
  },
  methods: {
    signIn() {
      this.$store.dispatch('signInWithPassword', this)
    }
  }
}
</script>

<style lang="stylus">
#signin-form {
  max-width: 400px;
  margin: 0 auto;
}

.facebook {
  background: rgb(59, 89, 152) !important;
}

.google {
  background: rgb(219, 68, 55) !important;
}
</style>
